import $ from 'cash-dom';
import BaseField from './BaseField';
import PodiumFilter from '../PodiumFilter';


class BaseInputField extends BaseField {
	constructor($input) {
		super($input);

		this._callbackFn = null;
		this._$resetButton = $('.filters-holder .reset');

		this._$resetButton.on('click', this._reset);

		this._$input.on('change', (e) => {
			e.preventDefault();
			this._filterInputs();
		});
	}

	_reset = (e) => {
		e.preventDefault();
		this._resetValue();

		this._filterInputs();
	}

	_resetValue() {
		this._$input.val(null);
	}

	_filterInputs() {
		const redirectLink = this._$input.data('link');

		if (redirectLink) {
			$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {redirectLink});
			return;
		}

		$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {
			filterName: this._$input.attr('name'),
			currentFieldValue: this.getValue(),
		});

		PodiumFilter.getInstance().filter();
	}

	/**
	 * Gets input label.
	 * @private
	 */
	_getLabel() {
		return this._$input.val().trim();
	}

	/**
	 * Sets value and triggers field specific event which was set by `on` method.
	 * @param {string|any} filterValue
	 */
	setValueAndTriggerEvent(filterValue) {
		this._$input.val(filterValue).trigger('change');
	}
}

export default BaseInputField;
